import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';

import { AdminLayout } from '@components/layout/AdminLayout';
import { ROUTES } from '@constants/routes';
import { STORAGE_KEYS } from '@constants/storage';
import { LoginPage } from '@features/auth/pages/LoginPage';
import { AdminDashboardPage } from '@features/admin/pages/AdminDashboardPage';
import { AppVersionsPage } from '@features/admin/pages/AppVersionsPage';

// Auth Guard: Only authenticated users can access the Admin portal
const ProtectedAdminLayout: React.FC = () => {
  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  if (!token) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }
  return <AdminLayout />;
};

export const router = createBrowserRouter([
  // Root path redirects directly to Login page
  {
    path: '/',
    element: <Navigate to={ROUTES.LOGIN} replace />,
  },

  // Standalone Login Page (Default landing page)
  {
    path: ROUTES.LOGIN,
    element: <LoginPage />,
  },

  // Protected Admin Portal Layout with Left Sidebar
  {
    path: ROUTES.ADMIN,
    element: <ProtectedAdminLayout />,
    children: [
      {
        index: true,
        element: <AdminDashboardPage />,
      },
      {
        path: 'app-versions',
        element: <AppVersionsPage />,
      },
      {
        path: '*',
        element: <Navigate to={ROUTES.ADMIN} replace />,
      },
    ],
  },

  // Fallback wildcard route redirects to Login
  {
    path: '*',
    element: <Navigate to={ROUTES.LOGIN} replace />,
  },
]);
